__webpack_require__.p = "/wp-content/plugins/theme-customisations-master-headless-wp/headless/templates/front/";